module.exports = __webpack_public_path__ + "fonts/visuelt-pro-light.1c698bb8.woff";